export default "__VITE_ASSET__Bjkx2wPb__"